import { Navigate, useLocation, useSearchParams } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import { startGoogleLogin } from '../api/client'

const ERROR_MESSAGES: Record<string, string> = {
  not_allowed: 'That Google account is not on the access list. Ask a manager to add you.',
  invalid_state: 'That sign-in link expired. Please try again.',
  missing_code: 'Google did not return an authorization code.',
  oauth_failed: 'Could not complete sign-in with Google.',
  access_denied: 'Sign-in was cancelled.',
}

export function Login() {
  const { user, loading } = useAuth()
  const location = useLocation() as { state?: { from?: string } }
  const [params] = useSearchParams()

  const error = params.get('error')
  const returnTo = location.state?.from ?? '/'

  if (loading) return <div className="centered muted">Loading…</div>
  if (user) return <Navigate to={returnTo} replace />

  return (
    <div className="centered">
      <div className="card login-card">
        <h1>Time Tracker</h1>
        <p className="muted">Sign in with your Soar Google account to log time.</p>

        {error && <p className="error">{ERROR_MESSAGES[error] ?? 'Sign-in failed.'}</p>}

        <button type="button" className="google-btn" onClick={() => startGoogleLogin(returnTo)}>
          <GoogleMark />
          Continue with Google
        </button>
      </div>
    </div>
  )
}

function GoogleMark() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.6l6.7-6.7C35.6 2.7 30.2.5 24 .5 14.6.5 6.4 5.9 2.6 13.7l7.8 6c1.8-5.4 6.9-9.4 13.6-10.2z" />
      <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.2-.4-4.7H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4 7.1-10 7.1-17.3z" />
      <path fill="#FBBC05" d="M10.4 28.3a14.3 14.3 0 0 1 0-8.6l-7.8-6a23.5 23.5 0 0 0 0 20.6l7.8-6z" />
      <path fill="#34A853" d="M24 47.5c6.2 0 11.5-2 15.4-5.6l-7.5-5.8c-2.1 1.4-4.8 2.2-7.9 2.2-6.7 0-11.8-4-13.6-9.4l-7.8 6C6.4 42.1 14.6 47.5 24 47.5z" />
    </svg>
  )
}
